import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import Heading from '../../../typography/Heading'
import styles from './styles'

const ModalHeader = ({ text, className }) => <Heading className={cx(styles.header, className)}>{text}</Heading>

ModalHeader.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
}

export default ModalHeader
